import styled from 'libs/styled';

const Path = styled('path')`
    stroke: ${props => props.stroke};
`;

export default Path;
